import { FreeSpinOverlayEvent, SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import gsap from "gsap";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { OverlayParticle } from "@lib/titan2/dist/game/view/display/AbstractOverlay";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { Container, Point } from "pixi.js";
import { FreeSpinsOverlay } from "@lib/titan2-slingo/dist/game/view/abstract/display/FreeSpinsOverlay";
import { Trail } from "./features/goldfish/Trail";
export class GameFreeSpinsOverlayParticle extends OverlayParticle {
    constructor() {
        super(...arguments);
        this.easeX = "none";
        this.easeY = "power2.in";
    }
}
/**
 * GameFreeSpinsOverlay.ts
 */
export class GameFreeSpinsOverlay extends FreeSpinsOverlay {
    addEventListeners() {
        super.addEventListeners();
        this.unregisterGame(SlingoEvent.REELS_AWARD);
        this.unregisterGame(FreeSpinOverlayEvent.FREE_SPIN_START);
        this.registerGame(SlingoEvent.REELS_AWARD, this.handleReelsAward);
        this.registerGame(CommonGameEvent.RECOVERY, this.handleReelsAward);
        this.registerGame(SlingoEvent.FREE_SPIN_AWARD, this.handleFreeSpinStart);
    }
    handleReelsAward() {
        this.freeSpinIndices = this.model.getSpinResult()?.getReelSequence().getFreeSpinIndexes() ?? [];
    }
    createParticles() {
        this.particles = new Dictionary();
        this.uiProperties.particleProperties.map((props, index) => {
            const particle = new GameFreeSpinsOverlayParticle(this.landscapeProperties.particleProperties[index], this.portraitProperties?.particleProperties[index]);
            const trail = new Trail(this.factory, this.landscapeProperties.trailProperties, this.portraitProperties.trailProperties);
            particle.addChild(trail);
            //@ts-ignore
            particle.entity = trail;
            particle.holder = new Container();
            particle.holder.addChild(particle);
            particle.holder.visible = false;
            this.addChild(particle.holder);
            return particle;
        }).forEach(particle => this.particles.setValue(particle.id, particle));
    }
    tweenParticle(particleId) {
        const particle = this.addParticle(particleId);
        particle.visible = true;
        const duration = 0.42;
        const entity = particle.entity;
        if (entity instanceof Trail) {
            const sourceWithOffset = new Point(particle.source.x + (this.landscapeProperties.particleProperties[0].sourceOffset.x), particle.source.y + (this.landscapeProperties.particleProperties[0].sourceOffset.y));
            const destinationWithOffset = new Point(particle.destination.x + (this.landscapeProperties.particleProperties[0].destinationOffset.x), particle.destination.y + (this.landscapeProperties.particleProperties[0].destinationOffset.y));
            const from = particle.parent.toGlobal(sourceWithOffset);
            const to = particle.parent.toGlobal(destinationWithOffset);
            entity.play(from, to);
        }
        gsap.timeline()
            .call(() => {
            this.dispatchGame(SlingoEvent.FREE_SPIN_TWEEN);
        })
            .call(() => {
            this.handleTweenComplete(particle);
        }, [], duration);
    }
}
//# sourceMappingURL=GameFreeSpinsOverlay.js.map